<div class="container">
    <div class="header">
        <div class="title">
            <span class="channel-name">{{ this.data?.reposeGroup.name }}</span>
            <span class="group-id"
                >{{ ('repose-group.dialog.title.edit-group-text' | translate) + (this.data?.reposeGroup.groupNo + 1) }}
            </span>
        </div>
        <button class="text-button" (click)="close()">
            {{ 'dlg.cancel' | translate }}
        </button>
    </div>
    <div class="content">
        <div class="content-box">
            <div class="sub-title">
                <h5 class="content-title">
                    {{ 'repose-group.dialog.sub-title' | translate }}
                </h5>
                <button
                    class="text-button"
                    data-cy="repose-modal-gen-info-edit-button"
                    (click)="openEditReposeGroupDialog(STEP1)">
                    {{ 'dlg.edit' | translate }}<mat-icon svgIcon="edit-pen" />
                </button>
            </div>
            <div class="data-container">
                <div class="title">
                    {{ 'repose-group.page.table.header.name' | translate }}
                </div>
                <div class="data">{{ getReposeName() }}</div>
            </div>
            <div class="data-container">
                <div class="title">
                    {{ 'repose-group.page.table.header.description' | translate }}
                </div>
                <div class="data">{{ data?.reposeGroup.description }}</div>
            </div>
        </div>
        <div class="content-box">
            <div class="sub-title">
                <h5 class="content-title">
                    {{ 'repose-group.dialog.configuration.title' | translate }}
                </h5>
                <button class="text-button" (click)="openEditReposeGroupDialog(STEP2)">
                    {{ 'dlg.edit' | translate }}<mat-icon svgIcon="edit-pen" />
                </button>
            </div>
            <div class="data-container" *ngIf="this.data.channel">
                <div class="title">
                    {{ 'repose-group.dialog.sub-title.channel' | translate }}
                </div>
                <div class="data">{{ getChannelName() }}</div>
                <div class="data-channelType">
                    {{ getReposeChannelType() }}
                </div>
            </div>
            <div class="data-container" *ngIf="this.data.channel">
                <div class="title">
                    {{ 'repose-group.dialog.sub-title.state' | translate }}
                </div>
                <div class="data">
                    {{ getTriggerCondition() + ' ' + getValue() }}
                </div>
            </div>
        </div>
    </div>
</div>
